import {putUpdateOralRemark} from '@/services/comment'
export default {
  namespaced: true,
  state: {

  },
  actions: {
    async updateOralRemark ({dispatch, commit}, payload) {
      const {callback, ...rest} = payload
      await putUpdateOralRemark(rest)
      callback && callback()
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/oral.js